import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Commands as GenericCommands } from '../../../../services/commands/commands';

@Injectable({
  providedIn: 'root',
})
export class Commands extends GenericCommands {

  constructor(protected override http: HttpClient){
    super(http, 'impostor');
  }

  public chooseName(
  
    name: string,
    successCallback?: Function

  ): void {

    this.postCommand(
      'name:choose',
      name,
      successCallback
    );

  }

  public startGame(successCallback?: Function): void {

    this.postCommand(
      'game:start',
      null,
      successCallback
    );

  }

  public votePlayer(
  
    name: string,
    successCallback?: Function

  ): void {

    this.postCommand(
      'player:vote',
      name,
      successCallback
    );

  }

  public guessWord(

    word: string,
    successCallback?: Function

  ): void {

    this.postCommand(
      'word:guess',
      word,
      successCallback
    );

  }
  
}
